
<template lang="html">

<el-form ref="form" v-form :model="form" addAction="business/insertBusiness.action" editAction="business/updateBusiness.action" selectAction="business/selectBusinessInfo.action" :rules="rules" label-width="150px">
    <el-col :span="12">
        <el-form-item label="对接人姓名" prop="abutmentPersonName">
            <el-input type="text" v-model="form.abutmentPersonName"></el-input>
        </el-form-item>
        <el-form-item label="对接人电话" prop="abutmentPhone">
            <el-input type="text" v-model="form.abutmentPhone"></el-input>
        </el-form-item>

        <el-form-item label="商家名称" prop="businessName">
            <el-input ref="business-name" v-model="form.businessName" placeholder="请输入商家名称"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
            <search-address-input ref="business-address" v-model="form.address" :defaultValue="form.address" @onChenged="onChange"></search-address-input>
        </el-form-item>
        <el-form-item label="服务类型" prop="serviceType">
            <el-select v-model="form.serviceType" multiple placeholder="请选择活动区域">
                <el-option label="新车" value="新车"></el-option>
                <el-option label="二手车" value="二手车"></el-option>
                <el-option label="保险" value="保险"></el-option>
                <el-option label="培训服务" value="培训服务"></el-option>
                <el-option label="维修保养" value="维修保养"></el-option>
                <el-option label="美容洗车" value="美容洗车"></el-option>
                <el-option label="汽车租赁" value="汽车租赁"></el-option>
                <el-option label="汽车配件" value="汽车配件"></el-option>
            </el-select>
        </el-form-item>
    </el-col>
    <el-col :span="12">
        <el-form-item>
            <el-amap ref="el-amap" vid="amap" :center="form.location" :zoom="zoom" class="amap" style="height:300px">
                <el-amap-marker :position="form.location"></el-amap-marker>
            </el-amap>
        </el-form-item>
    </el-col>

    <el-col>
        <el-form-item label="商家图片(最多9张)" prop="businessIcon">
            <el-upload  multiple :action="baseUrl+'upload/uploadPic'" v-model="form.businessIcon"  :data="{floder:'applyBusinessHeader',field:'businessIcon'}" list-type="picture-card" :file-list="form.businessIcon">
                <i class="el-icon-plus"></i>
            </el-upload>
        </el-form-item>
    </el-col>

    <el-col>
        <el-form-item v-belong-to-admin label="导流渠道" prop="clueChannels">
            <channel-select ref="clueChannel" :multiple="true" @change="clueChannelChange"></channel-select>
        </el-form-item>
    </el-col>
    <el-col>
        <el-form-item v-belong-to-admin label="展示渠道" prop="showChannels">
            <channel-select ref="showChannel" :multiple="true" @change="showChannelChange"></channel-select>
        </el-form-item>
    </el-col>

    <el-col>
        <el-form-item label="商家介绍">
            <el-input type="textarea" v-model="form.businessDesc"></el-input>
        </el-form-item>
    </el-col>
    <el-col>
        <el-form-item>
            <el-button type="primary">保存</el-button>
        </el-form-item>
    </el-col>

</el-form>

</template>

<script>

import Config from '@/framework/configs/Config'
import SearchAddressInput from './SearchAddressInput'
import BusinessModel from '@/framework/models/businessModel'
import channelSelect from '@/components/channelSelect'

export default {
  name: 'add-business',
  components: {
    SearchAddressInput,
    channelSelect
  },
  data: function () {
    let _this = this

    let validateLocation = (rule, value, callback) => {
      if (!_this.form.longitude && !_this.form.latitude) {
        return callback(new Error('请点击输入框选择一个位置信息'))
      } else {
        return callback()
      }
    }

    let validatePic = (rule, value, callback) => {
      if (!value) {
        callback(new Error('商家图片不能为空！'))
        return
      }

      if (value.length == 0) {
        callback(new Error('商家图片不能为空！'))
      } else if (value.length > 9) {
        callback(new Error('商家图片不能大于9张！'))
      } else {
        return callback()
      }
    }

    return {
      baseUrl: Config.baseUrl,
      form: {
        id: null,
        address: null,
        businessIcon: [],
        clueChannels: [],
        showChannels: [],
        areaName: null,
        serviceType: [],
        abutmentPersonName: null,
        abutmentPhone: null,
        businessName: null,
        longitude: null,
        latitude: null,
        location: [106.566129, 29.645191],
        areas: []
      },
      rules: {
        location: [{
          required: true,
          message: '地图坐标不能为空！'
        }],
        businessName: [{
          required: true,
          message: '商家名称不能为空'
        }],
        address: [{
          required: true,
          message: '详细地址不能为空',
          trigger: 'change'
        }, {
          validator: validateLocation,
          trigger: 'blur'
        }],
        serviceType: [{
          type: 'array',
          required: true,
          message: '服务类型不能为空',
          trigger: 'change'
        }],
        abutmentPersonName: [{
          required: true,
          message: '对接人姓名不能为空'
        }],
        abutmentPhone: [{
          required: true,
          message: '对接人电话不能为空'
        }, {
          max: 11,
          message: '电话号码不能大于11位',
          trigger: 'change'
        }],
        businessIcon: [{
          trigger: 'change',
          validator: validatePic
        }]
      },
      zoom: 18,
      plugin: [{
        pName: 'Scale',
        events: {
          init (instance) {}
        }
      }, {
        pName: 'ToolBar',
        events: {
          init (instance) {}
        }
      }],

      loading: false,
      pois: []
    }
  },
  created: function () {
    let id = this.$route.params.id
    this.form.id = id

    let userInfo = JSON.parse(localStorage.userInfo)
    let isChannel = userInfo.loginPath === 'channel'
    this.form.createPerson = userInfo.realName

    if (isChannel) {
      this.form.showChannels = [userInfo.id]
    }
  },
  methods: {
    onFilterParams: function (params) {
      params.address = params.address.replace(params.areaName + ' ', '')
    },
    onSelectInfo: function (info) {
      if (info.datas.clueChannels) {
        let array = info.datas.clueChannels.split(',')
        let channelIds = []
        for (var i = 0; i < array.length; i++) {
          let item = array[i]
          channelIds.push(parseInt(item))
        }

        this.$refs['clueChannel'].setChannelIds(channelIds)
      }

      this.form.address = info.datas.areaName + ' ' + info.datas.address

      if (info.datas.showChannels) {
        let array = info.datas.showChannels.split(',')
        let channelIds = []
        for (var i = 0; i < array.length; i++) {
          let item = array[i]
          channelIds.push(parseInt(item))
        }
        this.$refs['showChannel'].setChannelIds(channelIds)
      }
    },
    clueChannelChange: function (channels) {
      if (channels && channels.length) {
        this.form.clueChannels = channels
      } else {
        this.form.clueChannels = []
      }
    },
    showChannelChange: function (channels) {
      if (channels && channels.length) {
        this.form.showChannels = channels
      } else {
        this.form.showChannels = []
      }
    },
    onBusinessChange: function (addressInfo) {
      this.form.businessName = addressInfo.name

      this.onChange(addressInfo)
      this.$refs['business-name'].setText(addressInfo.name)
      this.$refs['business-address'].setText(addressInfo.value)
    },
    onChange: function (addressInfo) {
      // 查询省市区areaCode
      this.form.address = addressInfo.value

      this.form.areaName = addressInfo.province + ' ' + addressInfo.city + ' ' + addressInfo.county

      this.center = addressInfo.location.split(',')
      this.form.location = addressInfo.location.split(',')

      this.form.longitude = this.form.location[0]
      this.form.latitude = this.form.location[1]
    },
    querySearchAsync: function (queryString) {
      let _this = this
      let params = {
        keyword: queryString
      }

      let listener = {
        onResponse: function (res) {
          let json = JSON.parse(res.body)
          _this.pois = json.pois
        }
      }

      BusinessModel.findAMapLocations(_this, params, listener)
    },
    searchLocation: function (keyword) {
      if (!keyword) {
        return
      }

      let _this = this
      let listener = {
        onResponse: function (response) {
          let data = null
          if (typeof response.data === 'string') {
            data = JSON.parse(response.body)
          } else {
            data = response.body
          }

          let result = data.pois
          console.log(data)
          if (result && result.length) {
            _this.onChange(result[0])
          }
        }
      }
      BusinessModel.findAMapLocations(this, {
        'keyword': encodeURIComponent(keyword)
      }, listener)
    }
  }
}

</script>
